/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import * as S from "./Nav.styles";
import PropTypes from "prop-types";
import Logo from "../../assets/LKFnew.png";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRightFromBracket,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import LKFnew from "../../assets/LKFnew.png";
import MKLNoBG from "../../assets/MKLNoBG.png";

const Nav = ({ setActiveEn, activeEn, setActiveLt, activeLt }) => {
  const [active, setActive] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [mouseValue, setMouseValue] = useState();

  const navigate = useNavigate();

  const publicLinks = [
    {
      id: 1,
      url: "/",
      title: "Doping documents",
      image: LKFnew,
      navTitle: "DOPING",
    },
    {
      id: 2,
      url: "/mklentryfee",
      title: "MKL License fee",
      image: MKLNoBG,
      navTitle: "MKL",
    },
    {
      id: 3,
      url: "/clublogin",
      title: "Clubs",
      image: MKLNoBG,
      navTitle: "CLUBS",
    },
  ];

  const privateLinks = [
    {
      id: 1,
      url: "/clublogin/account",
      title: "Home",
      image: MKLNoBG,
      navTitle: "HOME",
    },
  ];

  const toggleClass = () => {
    setActive(!active);
  };

  const handleLogoClick = () => {
    if (localStorage.getItem("mklusertoken")) {
      return navigate("/clublogin/account");
    } else {
      return navigate("/");
    }
  };

  return (
    <S.Nav
      scrolled={scrolled}
      onScroll={() => setScrolled(!scrolled)}
      className="navbar scrolled"
    >
      <div className="navbar-wrapper is-flex is-hidden-desktop">
        <div className="navbar-content is-flex">
          <div className="navbar-item is-flex is-align-items-center">
            <figure className="logoimage">
              <img
                src={Logo}
                alt="LTU Basketball"
                onClick={() => {
                  handleLogoClick();
                }}
              />
            </figure>
          </div>
          <div
            role="button"
            aria-label="menu"
            aria-expanded="false"
            className={`navbar-burger ${
              active ? "is-active" : ""
            } js-burger has-background-white has-text-black`}
            onClick={() => {
              toggleClass();
            }}
          >
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <S.BurgerMenu active={active}>
          <div
            className={`navbar-menu is-flex is-flex-direction-column is-justify-content-center is-align-items-center ${
              active ? "is-active" : ""
            }`}
          >
            <div className="navbar-start">
              <div className="navbar-dropdown is-boxed">
                {localStorage.getItem("mklusertoken") ? (
                  <div className="menuMob is-flex is-flex-direction-column">
                    {privateLinks.map((link) => (
                      <Link
                        to={link.url}
                        key={link.id}
                        className="navbar-item is-flex is-justify-content-space-between is-align-items-center has-background-grey-lighter pt-4 pb-4"
                        onClick={() => {
                          toggleClass();
                        }}
                      >
                        <div className="navitems is-flex is-align-items-center">
                          <figure className="image mr-4">
                            <img src={link.image} alt={link.id} />
                          </figure>
                          <p className="subtitle is-6 mb-0">
                            <b>{link.title}</b>
                          </p>
                        </div>
                        <span className="icon-text">
                          <span className="icon">
                            <FontAwesomeIcon
                              icon={faChevronRight}
                              className="icon"
                            />
                          </span>
                        </span>
                      </Link>
                    ))}
                    <Link
                      className="navbar-item is-flex is-justify-content-space-between is-align-items-center has-background-grey-lighter pt-4 pb-4"
                      onClick={() => {
                        localStorage.removeItem("mklusertoken");
                        navigate("/clublogin");
                      }}
                    >
                      <div className="navitems is-flex is-align-items-center is-justify-content-center">
                        <span className="icon-text mr-2 ml-2 has-text-link">
                          <span className="icon is-normal">
                            <FontAwesomeIcon
                              icon={faArrowRightFromBracket}
                              className="icon is-normal"
                            />
                          </span>
                        </span>
                        <p className="subtitle is-6 mb-0">
                          <b>Logout</b>
                        </p>
                      </div>
                    </Link>
                  </div>
                ) : (
                  <div className="menuMob is-flex is-flex-direction-column">
                    {publicLinks.map((link) => (
                      <Link
                        to={link.url}
                        key={link.id}
                        className="navbar-item is-flex is-justify-content-space-between is-align-items-center has-background-grey-lighter pt-4 pb-4"
                        onClick={() => {
                          toggleClass();
                        }}
                      >
                        <div className="navitems is-flex is-align-items-center">
                          <figure className="image mr-4">
                            <img src={link.image} alt={link.id} />
                          </figure>
                          <p className="subtitle is-6 mb-0">
                            <b>{link.title}</b>
                          </p>
                        </div>
                        <span className="icon-text">
                          <span className="icon">
                            <FontAwesomeIcon
                              icon={faChevronRight}
                              className="icon"
                            />
                          </span>
                        </span>
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <div className="navbar-end">
              <div className="tabs is-small">
                <ul>
                  <li className={activeLt === true ? "is-active " : ""}>
                    <a
                      onClick={() => {
                        setActiveLt(activeLt === false ? !activeLt : activeLt);
                        setActiveEn(activeEn === false ? activeEn : !activeEn);
                        setActive(active === true ? !active : active);
                      }}
                    >
                      <b>LT</b>
                    </a>
                  </li>
                  <li className={activeEn === true ? "is-active" : ""}>
                    <a
                      onClick={() => {
                        setActiveLt(activeLt === false ? activeLt : !activeLt);
                        setActiveEn(activeEn === false ? !activeEn : activeEn);
                        setActive(active === true ? !active : active);
                      }}
                    >
                      <b>EN</b>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </S.BurgerMenu>
      </div>
      <div className="navbar-wrapper is-flex is-hidden-touch">
        <div className="navbar-content is-flex">
          <div className="navbar-item is-flex is-align-items-center">
            <figure className="image">
              <img
                src={Logo}
                alt="LTU Basketball"
                onClick={() => {
                  handleLogoClick();
                }}
              />
            </figure>
          </div>
          {localStorage.getItem("mklusertoken") ? (
            <div className="navbar-start ml-6">
              {privateLinks.map((link) => (
                <Link
                  to={link.url}
                  key={link.id}
                  id={link.id}
                  className="navbar-item is-flex is-justify-content-center is-align-items-center pt-4 pb-4 pl-2 pr-2"
                  onClick={() => {
                    toggleClass();
                  }}
                  onMouseEnter={() => {
                    setMouseValue({ id: link.id });
                  }}
                  onMouseLeave={() => {
                    setMouseValue();
                  }}
                >
                  <p
                    className={
                      mouseValue && mouseValue.id === link.id
                        ? "subtitle is-6 mb-0 has-text-black"
                        : "subtitle is-6 mb-0 has-text-white"
                    }
                  >
                    <b>{link.navTitle}</b>
                  </p>
                </Link>
              ))}
            </div>
          ) : (
            <div className="navbar-start ml-6">
              {publicLinks.map((link) => (
                <Link
                  to={link.url}
                  key={link.id}
                  id={link.id}
                  className="navbar-item is-flex is-justify-content-center is-align-items-center pt-4 pb-4 pl-2 pr-2"
                  onClick={() => {
                    toggleClass();
                  }}
                  onMouseEnter={() => {
                    setMouseValue({ id: link.id });
                  }}
                  onMouseLeave={() => {
                    setMouseValue();
                  }}
                >
                  <p
                    className={
                      mouseValue && mouseValue.id === link.id
                        ? "subtitle is-6 mb-0 has-text-black"
                        : "subtitle is-6 mb-0 has-text-white"
                    }
                  >
                    <b>{link.navTitle}</b>
                  </p>
                </Link>
              ))}
            </div>
          )}
          <div className="navbar-end">
            <div className="tabs is-small">
              <ul>
                <li className={activeLt === true ? "is-active " : ""}>
                  <a
                    onClick={() => {
                      setActiveLt(activeLt === false ? !activeLt : activeLt);
                      setActiveEn(activeEn === false ? activeEn : !activeEn);
                    }}
                  >
                    <b>LT</b>
                  </a>
                </li>
                <li className={activeEn === true ? "is-active" : ""}>
                  <a
                    onClick={() => {
                      setActiveLt(activeLt === false ? activeLt : !activeLt);
                      setActiveEn(activeEn === false ? !activeEn : activeEn);
                    }}
                  >
                    <b>EN</b>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          {localStorage.getItem("mklusertoken") ? (
            <div className="buttons are-small ml-4">
              <button
                className="button is-link"
                onClick={() => {
                  localStorage.removeItem("mklusertoken");
                  navigate("/clublogin");
                }}
              >
                <span className="icon-text mr-2 ml-2 has-text-white">
                  <span className="icon is-small">
                    <FontAwesomeIcon
                      icon={faArrowRightFromBracket}
                      className="icon is-small"
                    />
                  </span>
                </span>
                <b>Logout</b>
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </S.Nav>
  );
};

Nav.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      active: PropTypes.func,
    }),
  ),
};

export default Nav;
